import React, { ButtonHTMLAttributes } from 'react';

import {
	useClassNames,
} from '@common';

import './Button.scss';
import '../BusyArea.scss';

type themes = 'primary' | 'secondary' | 'danger' | 'warning' | 'ghost' | 'default' | 'primary-inverse' | 'default-inverse';
type sizes = 'small' | 'medium' | 'large' | 'nogap' | 'simmetric-small' | 'simmetric-smaller';
type shapes = 'default' | 'simmetric';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
	block?: boolean,
	theme?: themes,
	shape?: shapes,
	size?: sizes,
	isBusy?: boolean,
}

const Button = React.forwardRef<HTMLDivElement, ButtonProps>((props: ButtonProps, ref): JSX.Element => {
	const {
		shape = 'default',
		theme = 'default',
		size = 'medium',
		block = false,
		className,
		isBusy,
		...buttonProps
	} = props;

	const shapedSize = shape === 'default'
		? size
		: `${shape}-${size}`;

	const classes = useClassNames(
		'button',
		block ? 'block' : 'inline',
		isBusy ? 'busy' : '',
		shapedSize,
		className,
		theme
	);

	const wrapClasses = useClassNames(
		'button-wrap',
		className,
	);

	return (
		<div className={wrapClasses} ref={ref}>
			<button className={classes} {...buttonProps} />
			{isBusy
			?	<div className='busy-area'>
					<div className='busy-area-bar'></div>
				</div>
			: null}
		</div>
	);
});

const MemoisedButton = React.memo(Button);

export {MemoisedButton as Button};
export type {ButtonProps};